// extracted by mini-css-extract-plugin
export default {"inlineSpinner":"InlineSpinner_inlineSpinner__EJyL5","loadingSpinner":"InlineSpinner_loadingSpinner__HEpB6"};